var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"inherit"}},[_c('job-status-alert',{attrs:{"config":_vm.alertconfig}}),_c('router-view',{attrs:{"JobData":_vm.JobData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }